const requestColumns = [
  { key: 'Owner', label: 'Owner', type: 'text', width: 140 },
  { key: 'CreationDate', label: 'Created', type: 'date', width: 105 },
  { key: 'Client', label: 'Client', type: 'text', width: 130 },
  { key: 'Project', label: 'Project*', type: 'text', width: 130 },
  { key: 'Level', label: 'Level*', type: 'text', width: 150 },
  { key: 'StartDate', label: 'Start*', type: 'date', width: 105 },
  { key: 'EndDate', label: 'End*', type: 'date', width: 105 },
  { key: 'Type', label: 'Role', type: 'text', width: undefined },
  { key: 'Name', label: 'Suggested Name', type: 'text', width: 180 },
  { key: 'ContractorAllowed', label: 'Sub', type: 'boolean', width: 36 },
  { key: 'Adjudicated', label: 'Adj.', type: 'boolean', width: 36 },
  { key: 'Closed', label: 'Closed', type: 'boolean', width: 42 },
  { key: 'RC', label: 'RC', type: 'text', width: 80 },
  { key: 'Comments', label: 'Comments', type: 'text', width: undefined }
];

export default requestColumns;
